// Replace the Vite glob import with Webpack's require.context
const importAll = r => {
  const images = {};
  r.keys().forEach(key => {
    // Extract the filename with path but without extension
    // e.g., './weekend-ai-for-kids/WeekendAI01.jpg' becomes 'weekend-ai-for-kids/WeekendAI01'
    const imageName = key
      .replace('./', '') // Remove leading ./
      .replace(/\.(png|jpe?g|webp)$/, ''); // Remove extension
    images[imageName] = r(key);
  });
  return images;
};

// Import all images from the resources directory and its subdirectories
const blogImages = importAll(
  require.context('../resources', true, /\.(png|jpe?g|webp)$/)
);

// Helper function to get image path
const getImage = imageName => {
  return blogImages[imageName] || null;
};

// This structure mirrors how documents would look in MongoDB
// Status: published, draft, archived,
export const blogPosts = [
  {
    _id: 'weekend-ai-for-kids',
    slug: 'weekend-ai-for-kids',
    title: 'Weekend AI for Kids',
    subtitle: '',
    content: {
      description: [
        'Throughout the summer of 2024, we launched a series of "Weekend AI for Kids" workshops that combined English learning with hands-on AI and technology applications using a project-based approach. Students developed real-world skills such as creativity, teamwork, and problem-solving, while working on a large project throughout the course.',
      ],
      fullText: `
                <p>Throughout the summer of 2024, we launched a series of <b>"Weekend AI for Kids"</b> workshops that combined <b>English learning with hands-on AI and technology applications</b> using a <b>project-based approach</b>. Students developed <b>real-world skills</b> such as <b>creativity, teamwork, and problem-solving</b>, while working on a <b>large project</b> throughout the course.</p>
                <p>In the <b>Creative Arts with AI</b> course, students <b>designed their own heroes and creatures, built fantasy worlds, and crafted illustrated fairy tale books.</b></p>
                <p>In the <b>Introduction to Programming</b> course, students <b>explored Scratch visual programming, learned animation and coding fundamentals, and developed their own interactive adventures.</b></p>
                <p>🔹 <b>Join us in bringing AI-powered, project-based learning to more young minds!</b></p>
                <p>2024年夏天，我們推出了一系列 <b>「兒童AI週末工作坊」</b>，將<b>英語學習與AI及科技應用</b> 相結合，並採用 <b>專案式學習（PBL）</b>，讓孩子在實作中學習。孩子們在課程中培養了 <b>創造力、團隊合作與問題解決能力</b>，並在整個學習過程中完成了一個 <b>大型專案</b>。</p>
                <p>在 <b>「AI創意藝術」</b> 課程中，孩子們 <b>設計自己的英雄與奇幻生物，創造專屬的故事世界，並製作精美的插畫童話書。</b></p>
                <p>在 <b>「程式設計入門」</b> 課程中，孩子們 <b>學習Scratch視覺化編程，掌握動畫與程式設計概念，並打造互動式冒險故事。</b></p>
                <p>🔹 <b>讓我們一起將AI驅動的專案式學習帶入更多孩子的成長旅程！</b></p>
                <p><a href="https://www.facebook.com/EverydayAI.TW">https://www.facebook.com/EverydayAI.TW</a></p>
            `,
    },
    metadata: {
      author: 'John Liaw',
      publishDate: '2024-07-14',
      lastModified: '2024-07-14',
      readTime: '<1 min',
      tags: [
        'AIforKids',
        'STEAMlearning',
        'EnglishThroughInnovation',
        'ProjectBasedLearning',
        'FutureSkills',
        '兒童AI',
        'STEAM教育',
        '創新英語學習',
        '專案式學習',
        '未來技能',
      ],
    },
    media: {
      featuredImage: getImage('weekend-ai-for-kids/WeekendAI01'),
      thumbnailImage: getImage('weekend-ai-for-kids/WeekendAI01'),
      altText: 'Weekend AI for Kids',
      slideshow: [
        {
          src: getImage('weekend-ai-for-kids/WeekendAI01'),
          alt: 'Students smiling at the camera',
        },
        {
          src: getImage('weekend-ai-for-kids/WeekendAI02'),
          alt: 'Creative arts with AI workshop',
        },
        {
          src: getImage('weekend-ai-for-kids/WeekendAI03'),
          alt: 'Student taking a break',
        },
        {
          src: getImage('weekend-ai-for-kids/WeekendAI04'),
          alt: 'Student looking at their project',
        },
        {
          src: getImage('weekend-ai-for-kids/WeekendAI05'),
          alt: 'Student working with Scratch',
        },
      ],
    },
    seo: {
      metaTitle: '兒童AI週末工作坊 | Kinetic101',
      metaDescription: '兒童AI週末工作坊',
      keywords: ['兒童AI週末工作坊', 'AI創意藝術', '程式設計入門'],
    },
    status: 'published',
    featured: true,
  },
  {
    _id: 'english-ai-winter-camp-for-kids',
    slug: 'english-ai-winter-camp-for-kids',
    title: 'English+AI Winter Camp for Kids',
    subtitle: '',
    content: {
      description: [
        'At our "English+AI Winter Camp for Kids", we combined English learning, Project-Based Learning (PBL), and AI into engaging daily themes such as art, cooking, music, science, and geography.',
      ],
      fullText: `
                <p>At our <b>"English+AI Winter Camp for Kids"</b>, we combined <b>English learning, Project-Based Learning (PBL), and AI</b> into engaging daily themes such as <b>art, cooking, music, science, and geography.</b></p>
                <p>Students participated in <b>hands-on projects</b> like building bridges and marshmallow towers, writing songs, baking cookies, inventing new eating tools, playing chess, and using AI to transform sketches into digital masterpieces. Through these activities, children developed <b>creativity, problem-solving skills, teamwork, and tech fluency</b>, preparing them for the challenges of the future.</p>
                <p>在我們的<b>「English+AI冬令營」</b>，我們將<b>英語學習、專案式學習（PBL）與人工智慧（AI）</b>結合到每日主題中，包括<b>藝術、烹飪、音樂、科學與地理</b>，讓孩子在動手實作中學習與成長。</p>
                <p>孩子們透過一系列互<b>動式專案</b>，如<b>搭建橋樑與棉花糖塔、創作歌曲、烘焙餅乾、發明創新餐具、下西洋棋，以及運用AI將手繪草圖轉換為數位藝術</b>，在玩樂中培養創<b>造力、問題解決能力、團隊合作與科技素養</b>，為未來挑戰做好準備！</p>
                <p><a href="https://www.facebook.com/EverydayAI.TW">https://www.facebook.com/EverydayAI.TW</a></p>
            `,
    },
    metadata: {
      author: 'John Liaw',
      publishDate: '2024-01-29',
      lastModified: '2024-01-29',
      readTime: '<1 min',
      tags: [
        'EnglishLearning',
        'AIinEducation',
        'STEAM',
        'ProjectBasedLearning',
        'FutureSkills',
        'EducationInnovation',
        '英語學習',
        'AI教育',
        'STEAM',
        '專案式學習',
        '未來技能',
        '教育創新',
      ],
    },
    media: {
      featuredImage: getImage(
        'english-ai-winter-camp-for-kids/English+AI Winter Camp for Kids01'
      ),
      thumbnailImage: getImage(
        'english-ai-winter-camp-for-kids/English+AI Winter Camp for Kids01'
      ),
      altText: 'English+AI Winter Camp for Kids',
      slideshow: [
        {
          src: getImage(
            'english-ai-winter-camp-for-kids/English+AI Winter Camp for Kids01'
          ),
          alt: 'Image 1',
        },
        {
          src: getImage(
            'english-ai-winter-camp-for-kids/English+AI Winter Camp for Kids02'
          ),
          alt: 'Image 2',
        },
        {
          src: getImage(
            'english-ai-winter-camp-for-kids/English+AI Winter Camp for Kids03'
          ),
          alt: 'Image 3',
        },
        {
          src: getImage(
            'english-ai-winter-camp-for-kids/English+AI Winter Camp for Kids04'
          ),
          alt: 'Image 4',
        },
        {
          src: getImage(
            'english-ai-winter-camp-for-kids/English+AI Winter Camp for Kids05'
          ),
          alt: 'Image 5',
        },
        {
          src: getImage(
            'english-ai-winter-camp-for-kids/English+AI Winter Camp for Kids06'
          ),
          alt: 'Image 6',
        },
        {
          src: getImage(
            'english-ai-winter-camp-for-kids/English+AI Winter Camp for Kids07'
          ),
          alt: 'Image 7',
        },
        {
          src: getImage(
            'english-ai-winter-camp-for-kids/English+AI Winter Camp for Kids08'
          ),
          alt: 'Image 8',
        },
      ],
    },
    seo: {
      metaTitle: 'English+AI冬令營 | Kinetic101',
      metaDescription: 'English+AI冬令營',
      keywords: [
        'English+AI冬令營',
        '英語學習',
        'AI教育',
        'STEAM',
        '專案式學習',
        '未來技能',
        '教育創新',
      ],
    },
    status: 'published',
    featured: true,
  },
  {
    _id: 'english-ai-workshop-for-kids',
    slug: 'english-ai-workshop-for-kids',
    title: 'English+AI Workshop for Kids',
    subtitle: '',
    content: {
      description: [
        'In January 2024, we launched our first pilot program, "English + AI Workshop for Kids." This workshop combined English learning with AI exploration, giving students an early introduction to practical AI applications. Through engaging activities, children learned English through AI-related concepts while developing their creativity in storytelling and image creation.',
      ],
      fullText: `
                <p>In January 2024, we launched our first pilot program, <b>"English+AI Workshop for Kids"</b>. This workshop <b>combined English learning with AI exploration</b>, giving students an early introduction to <b>practical AI applications</b>. Through engaging activities, children <b>learned English through AI-related concepts</b> while developing their creativity in <b>storytelling and image creation</b>.</p>
                <p>2024年1月，我們成功推出首場試點課程！我們的**<b>「英語 + AI 兒童工作坊」</b>巧妙結合<b>英語學習與AI探索**</b>，讓孩子從小接觸<b>AI的實際應用</b>。透過有趣的互動活動，孩子們用AI語言學英語，並透過<b>故事創作與圖像生成</b>發揮創意！</p>
                <p><a href="https://www.facebook.com/EverydayAI.TW">https://www.facebook.com/EverydayAI.TW</a></p>
            `,
    },
    metadata: {
      author: 'John Liaw',
      publishDate: '2024-01-14',
      lastModified: '2024-01-14',
      readTime: '<1 min',
      tags: [
        'AIinEducation',
        'EnglishLearning',
        'FutureSkills',
        'CreativeThinking',
        'TaiwanEducation',
        'AI教育',
        '英語學習',
        '未來技能',
        '創意思維',
        '台灣教育',
      ],
    },
    media: {
      featuredImage: getImage(
        'english-ai-workshop-for-kids/English+AI Workshop for Kids01'
      ),
      thumbnailImage: getImage(
        'english-ai-workshop-for-kids/English+AI Workshop for Kids01'
      ),
      altText: 'English+AI Workshop for Kids',
      slideshow: [
        {
          src: getImage(
            'english-ai-workshop-for-kids/English+AI Workshop for Kids01'
          ),
          alt: 'Image 1',
        },
        {
          src: getImage(
            'english-ai-workshop-for-kids/English+AI Workshop for Kids02'
          ),
          alt: 'Image 2',
        },
        {
          src: getImage(
            'english-ai-workshop-for-kids/English+AI Workshop for Kids03'
          ),
          alt: 'Image 3',
        },
        {
          src: getImage(
            'english-ai-workshop-for-kids/English+AI Workshop for Kids04'
          ),
          alt: 'Image 4',
        },
      ],
    },
    seo: {
      metaTitle: 'English+AI工作坊 | Kinetic101',
      metaDescription: 'English+AI工作坊',
      keywords: [
        'English+AI工作坊',
        '英語學習',
        'AI教育',
        '創意思維',
        '台灣教育',
      ],
    },
    status: 'published',
    featured: true,
  },
];

// Helper functions to get different sets of blogs
export const blogPostSets = {
  FEATURED: blogPosts.filter(post => post.featured),
  PUBLISHED: blogPosts.filter(post => post.status === 'published'),
  ALL: blogPosts,
};

// Helper function to get a blog by slug
export const getBlogBySlug = slug => blogPosts.find(post => post.slug === slug);

// Helper function to get blogs by tag
export const getBlogsByTag = tag =>
  blogPosts.filter(post => post.metadata.tags.includes(tag));
